// extracted by mini-css-extract-plugin
export default {"fadeImg":"NftTile_fadeImg__oSRKS"};